/* eslint-disable no-underscore-dangle */
import { connect, useDispatch } from 'react-redux';
import { ChangeEvent, useState } from 'react';
import * as R from 'ramda';

import { coreShowNotice } from 'CorePackage/MainModule/actions/coreActions';
import { isFilesSizeValid } from 'CorePackage/MainModule/common/isFilesSizeValid';
import { MB } from 'CorePackage/MainModule/constants/fileSize';
import { NoticeTypesEnum } from 'CorePackage/MainModule/enums/NoticeTypesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IUploadFile } from 'CorePackage/MainModule/interfaces/IUploadFile';
import { feedbackUploadFile } from 'FeedbackPackage/MainModule/actions/feedbackActions';
import { getFeedbackFiles } from 'FeedbackPackage/MainModule/reducers/feedbackReducer';

import styles from './UploadInput.module.scss';
import { isFileExtensionValid } from '../common/isFileExtensionValid';

const ERROR_SIZE = 'Суммарный объем файлов не должен превышать 40MB';
const ERROR_EXT = 'Недопустимый формат файла';
const KNM_FILE_SIZE_ERROR_SMALL = 'Размер файла не может превышать 5 МБ';
const validExtensions = ['ods', 'doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png', 'rar', 'xlsx', 'xls', 'zip', 'txt', 'rtf'];

export interface IUploadInputProps {
  files: IUploadFile[];
  error?: string;
  invalidExtensions?: string[];
  setError?: (error: string) => void;
}

const UploadInputWithoutStore = ({ files, error, invalidExtensions, setError }: IUploadInputProps) => {
  const dispatch = useDispatch();
  const [sameNameCount, setSameNameCount] = useState(1);
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const targetFiles = e.target.files;
    if (!targetFiles) {
      return;
    }
    const file = targetFiles[0];
    const fileName = file.name;
    const ext =
      invalidExtensions && invalidExtensions.length > 0
        ? R.reject(R.contains(R.__, invalidExtensions), validExtensions)
        : validExtensions;
    if (!isFileExtensionValid(fileName, ext)) {
      dispatch(coreShowNotice(ERROR_EXT, NoticeTypesEnum.WARNING));
      return;
    }
    if (!isFilesSizeValid(files, file.size)) {
      dispatch(coreShowNotice(ERROR_SIZE, NoticeTypesEnum.ERROR));
      setError && setError(ERROR_SIZE);
      return;
    }
    if (file.size > 5 * MB) {
      dispatch(coreShowNotice(KNM_FILE_SIZE_ERROR_SMALL, NoticeTypesEnum.ERROR));
      setError && setError(KNM_FILE_SIZE_ERROR_SMALL);
      return;
    }
    let nameIfFileExists: string = '';
    if (files.find(f => f.fileName === fileName)) {
      const index = fileName.lastIndexOf('.');
      nameIfFileExists = `${fileName.slice(0, index)}(${sameNameCount})${fileName.slice(index)}`;
      setSameNameCount(sameNameCount + 1);
    }
    dispatch(feedbackUploadFile(e, nameIfFileExists));
    e.target.value = '';
  };

  return (
    <div className={styles.Block}>
      <div>
        <span className={styles.Label}>Документы</span>
        <label className={styles.LoadButton}>
          Добавить
          <input className={styles.Input} type="file" name="load" onChange={handleFileChange} />
        </label>
      </div>
      {error && <div className={styles.Error}>{error}</div>}
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  files: getFeedbackFiles(state),
});

export const UploadInput = connect(mapStateToProps)(UploadInputWithoutStore);
